import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.notificationsAlarms'),
    id: 'generalNotifications',
    sidebar: [
        {
            id: 'notifications-global',
            label: i18n.tc('configuration.sections.notificationType', 2),
            icon: 'fal fa-envelope',
            routeName: 'GlobalNotificationTypes',
            active: true
        }
    ]
}
